<template>
    <div class="flex flex-col gap-6">
        <h2 class="title-body text-ink">{{ t("myWorkInsightFeed.weeklyHeading", { range: weekRange }) }}</h2>
        <div class="body text-ink-muted text-pretty">
            <p>{{ t("myWorkInsightFeed.weekComplete") }}</p>
            <p>{{ t("myWorkInsightFeed.feedbackThanks") }}</p>
            <p>{{ t("myWorkInsightFeed.nextArrival", { date: nextArrival }) }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useNow } from "@vueuse/core";
import { formatDate, formatDateRange } from "~vue/utils/formatDate";
import { DateTime } from "luxon";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const now = useNow({ interval: 60_000 });
const weekStart = computed(() => DateTime.fromJSDate(now.value).startOf("week"));
const weekRange = computed(() => formatDateRange(weekStart.value, weekStart.value.plus({ days: 6 }), "month-day"));
const nextArrival = computed(() => formatDate(weekStart.value.plus({ weeks: 1 }), "month-day"));
</script>
